import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-layers-icon',
  templateUrl: './design-layers.component.html'
})
export class DesignLayersComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
